module.exports = {
    message: {
        homeNavi: '首頁',
        aboutNavi: '關於',
        testNavi: '測試頁面',
        hello: '你好，世界',
        welcome: '這是一個簡單的使用Vuejs和TypeScript的項目。現在將其當作首頁。',
        welcomeParagraphs: '這是BanG Dream! moe網站的首頁。之前一直沒有啟用，顯示的是Nginx安裝成功後的歡迎頁面。按近期網站的發展藍圖，首頁將增添一些功能，此頁面代表網站正在施工中，敬請期待。',
    }
}